import React, {useEffect, useState} from 'react';
import { Formik, Form, Field } from 'formik';
import {useNavigate} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import { useModal } from '../../contexts/ModalContext';
import { importUserApi, validateFormImport } from "../../services/UserService";
import form_styles from "../../components/Form/Form.module.css";
import FieldCustom from "../../components/Field/FieldCustom";
import {useUser} from "../../contexts/UserContext";
import FieldPassword from "../../components/Field/FieldPassword";
import FieldCheckbox from "../../components/Field/FieldCheckbox";
import stylesField from "../../components/Field/Field.module.css";
import Routing from "../../services/routing";

function ImportSalariePage() {
    const { user } = useUser();
    const { showModal, hideModal } = useModal();
    const [inputs, setInputs] = useState([]);
    const [initialValues, setInitialValues] = useState({
        nom: '',
        prenom: '',
        date_naissance: '',
        email: '',
        mobile: '',
        civilite: '',
    });
    const navigate = useNavigate();

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 3000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 3000});
    };

    useEffect(() => {
        if (user && !user.roles.includes("ROLE_ADMIN") && !user.roles.includes("ROLE_REFERENT")) {
            return navigate('/');
        }

        const newInputs = [
            { type: 'text', name: 'nom', label: 'Nom', value: ''},
            { type: 'text', name: 'prenom', label: 'Prénom', value: '' },
            { type: 'date', name: 'date_naissance', label: 'Date de naissance', value: '' },
            { type: 'email', name: 'email', label: 'Email', value: '' },
            // { type: 'number', name: 'mobile', label: 'Mobile', value: '' },
        ];
        setInputs(newInputs);

        const newInitialValues = newInputs.reduce((acc, input) => ({
            ...acc,
            [input.name]: input.value,
        }), {});

        setInitialValues(newInitialValues);
    }, [user]);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await importUserApi(values);
            if (response.success){
                handleSuccess(response.message);

                setTimeout(() => {
                    if (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_REFERENT")) {
                        navigate(Routing.routes.salaries);
                        return;
                    }

                    navigate(Routing.routes.login, { state: { email: response.email } });
                }, 1500);
            } else {
                console.error("error", response);
                handleError(response.message);
            }
        } catch (error) {
            handleError( "Une erreur est survenue : "+ error.message);
            console.error(error);
        }
        setSubmitting(false);
    };


    return (
        <div className="content">
            <TitleMain text="PROFIL DU NOUVEL UTILISATEUR"/>
            {
                <Formik
                    initialValues={initialValues}
                    validate={validateFormImport}
                    onSubmit={handleSubmit}
                >
                    {formik => (
                        <Form className={form_styles.form}>
                            <div className={stylesField.select}>
                                <span>Civilité</span>
                                <Field as="select" name="civilite">
                                    <option>
                                        -- Sélectionnez une civilité --
                                    </option>
                                    <option value={"4"}>
                                        Monsieur
                                    </option>
                                    <option value={"3"}>
                                        Madame
                                    </option>
                                </Field>
                            </div>
                            {inputs.map(({type, name, label}, index) => {
                                let FieldComponent = FieldCustom;
                                if (type === 'password') {
                                    FieldComponent = FieldPassword;
                                } else if (type === 'checkbox') {
                                    FieldComponent = FieldCheckbox;
                                }
                                return (
                                    <div key={index}>
                                        <FieldComponent name={name} label={label} type={type}/>
                                    </div>
                                );
                            })}

                            <button type="submit" className={`${form_styles.btnSubmit} btn`}>IMPORTER</button>
                        </Form>
                    )}
                </Formik>
            }
        </div>
    );
}

export default ImportSalariePage;
